// src/crm/components/PlatformBadge.tsx
const PLATFORM_COLORS: Record<string, { bg: string; fg: string }> = {
  instagram: { bg: '#833AB4', fg: '#fff' },
  tiktok:    { bg: '#010101', fg: '#fff' },
  youtube:   { bg: '#FF0000', fg: '#fff' },
  twitter:   { bg: '#1DA1F2', fg: '#fff' },
  x:         { bg: '#1DA1F2', fg: '#fff' },
  linkedin:  { bg: '#0A66C2', fg: '#fff' },
  facebook:  { bg: '#1877F2', fg: '#fff' },
}

interface PlatformBadgeProps {
  platform: string
}

export function PlatformBadge({ platform }: PlatformBadgeProps) {
  const colors = PLATFORM_COLORS[platform.toLowerCase()] ?? {
    bg: 'var(--elevated)',
    fg: 'var(--muted)',
  }
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '0.125rem 0.4375rem',
        borderRadius: '4px',
        fontSize: '0.6875rem',
        fontWeight: 600,
        letterSpacing: '0.02em',
        textTransform: 'capitalize',
        background: colors.bg,
        color: colors.fg,
        marginRight: '0.25rem',
      }}
    >
      {platform}
    </span>
  )
}
